import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

export interface FooterConfig {
  footerType: 'default' | 'satrack' | 'solera';
  companyName?: string;
  email?: string;
  phone?: string;
  displayEmail?: string;
  emailIcon?: string;
  phoneIcon?: string;
  supportUrl?: string;
  supportText?: string;
  supportIcon?: string;
  privacyPolicy?: string;
  privacyText?: string;
}

@Component({
  selector: 'app-common-footer',
  templateUrl: './common-footer.component.html',
  styleUrls: ['./common-footer.component.scss'],
})
export class CommonFooterComponent implements OnChanges {
  @Input() footerConfig: any = { footerType: 'default' };
  public data: { copyrightyear: number } = { copyrightyear: new Date().getFullYear() };

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.footerConfig.currentValue.footerType === 'satrack') {
      /**
       * NOTE:
       * Dont replicate this. This overrides the parent CSS in case when sartrack footer is rendered.
       * This will breach the scope and will be difficult to debug later.
       */
      const css =
        '.landing-page {height: 100vh; overflow: auto} .content-large-footer {min-height: 55vh} .content-text-large-footer {top: 50% !important}';
      const head = document.getElementsByTagName('head')[0];
      const style = document.createElement('style');
      style.type = 'text/css';
      style.appendChild(document.createTextNode(css));
      head.appendChild(style);
    }
  }
}
